import { Component, Input, OnInit } from "@angular/core";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-layout-image-list",
  templateUrl: "./layout-image-list.component.html",
  styleUrls: ["./layout-image-list.component.scss"],
})
export class LayoutImageListComponent implements OnInit {
  @Input() inputData: any;

  dummyItems = [{}];
  selectedLanguage = "";
  font = "";
  ContentData: any;
  News_event_data: any;
  foundnews: any;

  constructor(private appService: AppService) {}

  ngOnInit(): void {
    this.selectedLanguage = localStorage.getItem("selectedLanguage") || "en";
    this.FetchData();
  }

  truncateText(text: string, maxLength: number): string {
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
  }

  FetchData(): void {
    this.appService.getContents().subscribe((response: any) => {
      console.log(response, "response FetchData");

      this.ContentData = response.data;
      console.log(this.ContentData, "Default Content Data");

      if (this.ContentData != null) {
        let news = this.ContentData.filter(
          (x) => x.ContentCategoryName == "Achievements"
        );
        news.sort((a: any, b: any) => b.Id - a.Id);
        this.News_event_data = news;
        console.log(this.News_event_data, "All Achievements Data");
      }
    });
  }

  GetFontName(): string {
    switch (this.selectedLanguage) {
      case "en":
        return "Congenial";
      case "bn":
        return "Kalpurush";
      case "ar":
        return "Jameel Noori Nastaleeq";
      default:
        return "Congenial";
    }
  }
}
